// @ts-ignore no types
import React, { useState, useRef, useEffect, useMemo } from 'react'
// @ts-ignore no types
import moment from 'moment'
// @ts-ignore no types
import { connect } from 'react-redux'
// @ts-ignore no types
import {
  Text,
  Icon,
  Button,
  useApplicationContext,
  // @ts-ignore no types
} from '@adc/ui-adc'
import * as blueprint from '@adc/blueprint'
import * as graph from '@adc/sdk'
// @ts-ignore no types
import classnames from 'classnames/bind'
// @ts-ignore no types
import smoothscroll from 'smoothscroll-polyfill'
import { FeatureFlags, useListingContext } from 'common/context/listing'
import { usePropertyContext } from '../../context/property'
import SparkOfferButton from '../../components/sparkOfferButton'
import {
  RegistrationButton,
  SavePropertyIconButton,
} from '../auctionDetails/template'
import {
  formatMoneyWithNumeral,
  formatMoneyWithCentsExceptZero,
  formatNumber,
} from '../../utils/formatters'
import hasSimilarProperties from '../../utils/hasSimilarProperties'
import {
  getServerTimeMoment,
  getStartTimeMoment,
  Starting,
} from '../auctionCountdown'
import {
  COMING_SOON,
  PENDING_SOLD,
  SALE_PENDING,
  SOLD,
  SOLD_LABEL,
  PLACE_BID,
  AUCTION_DETAILS_CTA_ID,
  SAVE_PROPERTY_CTA_TPS,
  POSTPONED,
  POSTPONED_TO,
} from '../../statics'
import { SALE_TERMS_ELM_ID } from '../redesign/saleTerms'
import BidAtCountySite from '../auctionDetails/bidAtCountySite'
import AssetType from '../propertyHeader/assetType'
import { withModalHooks } from '../../hooks/useModalFeatures'
import { getListPrice } from '../../utils/listing'
import { shouldShowSealedBidTreatment } from '../../utils/privateSeller'
import { SealedBidCallToAction } from '../sealedBid'
import { isAuctionSold } from '../auctionDetails/utils'
import Label from './label'
import Detail from './detail'
// @ts-ignore no types
import styles from './index.scss'

const cx = classnames.bind(styles)

// Gets the top position of the element in reference to the DOM
const getTopPosition = (el: HTMLElement | null) => {
  let y = 0
  while (el) {
    y += el.offsetTop
    // TODO: not sure how to solve this type problem since offsetParent is of type Element not HTMLElement
    el = el.offsetParent as HTMLElement | null
  }
  return y
}

// Gets the top position of the element taking into account the header's height
const getOffsetTop = (el: HTMLElement | null) => {
  const top = getTopPosition(el)
  let y = top
  while (el) {
    y -= el.offsetTop
    el = el.parentElement
  }
  return top + y
}

interface StickyHeaderProps {
  similarProperties: any[]
  isPropertyReportAvailable: boolean
  actions: any
  featureFlags: FeatureFlags
  isRedesign?: boolean
}

const StickyHeaderFunctional = (props: StickyHeaderProps) => {
  const {
    similarProperties,
    isPropertyReportAvailable,
    featureFlags,
    isRedesign,
  } = props

  /**
   * this is one of the few files that handles segment logic for either live or online segments, useListingContext currently assumes online auction segment
   * which works for most of the files that ONLY handle online segments anyways. Ideally there would be a hard split between both the contexts and the files unless a better approach is suggested,
   * otherwise, every file that wants to use the types will have to handle cases for both online and live since the context says the segment can be either type.
   */
  const { segment, listing } = useListingContext()
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  const { embeddedContext } = useApplicationContext()

  const [showHeader, setShowHeader] = useState(false)
  const [activeLink, setActiveLink] = useState('')

  const showHeaderRef = useRef(showHeader)

  const { property, propertyActions } = usePropertyContext()
  const isPropertySaved = property.is_currently_saved

  useEffect(() => {
    showHeaderRef.current = showHeader
  }, [showHeader])

  const isSparkOffer = listing.__methods__.isSparkOffer()
  const shouldDisplayListPrice = listing.__methods__.shouldDisplayListPrice()

  const links = useMemo(
    () => [
      {
        link: 'property_details',
        label: 'Property Details',
        elmId: 'sticky_header_link_property_details',
      },
      {
        link: 'similar_properties',
        label: 'Similar Properties',
        elmId: 'sticky_header_link_similar_properties',
        condition: () => hasSimilarProperties(similarProperties),
      },
      {
        link: 'comp_sales',
        label: 'Market Analysis',
        elmId: 'sticky_header_link_market_analysis',
        condition: () => isPropertyReportAvailable,
      },
      {
        link: 'due_diligence',
        label: 'Due Diligence',
        elmId: 'sticky_header_link_due_diligence',
        condition: () => !isSparkOffer,
      },
      {
        link: 'faqs',
        label: "Top FAQ's",
        elmId: 'sticky_header_link_faqs',
        condition: () => !isSparkOffer,
      },
    ],
    [isPropertyReportAvailable, isSparkOffer, similarProperties]
  )

  const fields = [
    {
      label: 'Beds',
      fieldPath: 'total_bedrooms',
      elmId: 'sticky_header_bed_count',
      format: formatNumber,
    },
    {
      label: 'Baths',
      fieldPath: 'total_bathrooms',
      elmId: 'sticky_header_bath_count',
      format: formatNumber,
    },
    {
      label: 'Sq. Feet',
      fieldPath: 'living_size',
      elmId: 'sticky_header_square_feet',
      format: formatNumber,
    },
  ]

  const getLinksActiveTop = (id: string) => {
    const el = document.getElementById(id)
    if (!el) return null
    return el.offsetTop - 200
  }

  const scrollToAnchor =
    (link: string, offset = 120) =>
    () => {
      const elem = window.document.getElementById(link)
      if (elem) {
        window.scrollTo({
          top: elem.offsetTop - offset,
          behavior: 'smooth',
        })
      }
    }

  useEffect(() => {
    // Polyfill window.scrollTo to get smooth scrolling on IE, edge, and mobile safari.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    smoothscroll.polyfill()

    const handleScroll = () => {
      const auctionDetails = window.document.getElementById(
        AUCTION_DETAILS_CTA_ID
      )

      const saleTermsSection =
        isRedesign &&
        auctionDetails &&
        window.document.getElementById(SALE_TERMS_ELM_ID)

      const targetReferencePoint = saleTermsSection || auctionDetails
      const top = targetReferencePoint
        ? getOffsetTop(targetReferencePoint)
        : 400

      if (window.scrollY >= top && !showHeaderRef.current) {
        setShowHeader(true)
      } else if (window.scrollY < top && showHeaderRef.current) {
        setShowHeader(false)
      }

      const currentlyActiveLink = links.reduce((memo, anchor) => {
        const activeTop = getLinksActiveTop(anchor.link)
        if (activeTop && window.scrollY >= activeTop) {
          return anchor.link
        }
        return memo
      }, '')
      activeLink !== currentlyActiveLink && setActiveLink(currentlyActiveLink)
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [links, activeLink, isRedesign])

  const renderLabels = () => {
    const { listing_configuration } = listing
    const { postponement_new_auction_date } = listing_configuration || {}

    if (shouldDisplayListPrice) {
      // @ts-ignore TODO:
      return <Label text='List Price' bold={getListPrice(listing)} />
    }

    if (listing.is_coming_soon) {
      return <Label text={COMING_SOON} />
    }

    if (
      listing.__methods__.isCancelled() //  bidding Status.isAuctionCancelled || bidding Status.didAuctionFallOut // this checks if it's tps ohio and auction status is unknown
    ) {
      return <Label text='Cancelled' />
    }

    if (listing.__methods__.isPostponed()) {
      return (
        <Label
          text={
            postponement_new_auction_date
              ? `${POSTPONED_TO} ${moment(
                  postponement_new_auction_date,
                  'YYYY-MM-DD'
                ).format('MMM DD')}`
              : POSTPONED
          }
        />
      )
    }

    if (
      segment?.segment_status ===
        graph.enums.OnlineAuctionSegmentStatus.Ended &&
      segment?.subject_to_status === graph.enums.SubjectToStatus.Pending &&
      listing.listing_status !== graph.enums.ListingStatus.Closed
    )
      // bStatus.isSoldPending
      return <Label text={PENDING_SOLD} />
    else if (
      listing.listing_status_group === graph.enums.ListingStatusGroup.Pending ||
      isAuctionSold(listing)
    ) {
      // bidding Status.isAuctionGoneOrSold
      return (
        // this used to be the logic, saving here for reference while testing, there could be weird combinations around REO or FCL online, also this may need some more specific cases for fallout as that would reside in status_label before
        // bidding Status.isREO && bStatus.isAuctionSold
        //   ? SOLD_LABEL
        //   : bidding Status.statusLabel
        <Label text={isAuctionSold(listing) ? SOLD_LABEL : 'Pending'} />
      )
    } else if (segment?.bid_count && segment?.bid_count > 0)
      // bidding Status.hasBids
      return (
        <Label
          text='Current Bid'
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          bold={formatMoneyWithNumeral(
            segment?.current_highest_bid?.bid_amount,
            'TBD'
          )}
        />
      )
    else if (
      listing.__methods__.showOpeningBid() &&
      segment?.starting_bid_amount
    ) {
      const openingBid =
        listing.listing_configuration?.asset_type ===
        graph.enums.AssetType.Foreclosure // bidding Status.isTPSOnline
          ? formatMoneyWithCentsExceptZero(segment?.starting_bid_amount, 'TBD')
          : formatMoneyWithNumeral(segment?.starting_bid_amount, 'TBD')
      return <Label text='Opening Bid' bold={openingBid} />
    }
    return null
  }

  const renderCta = () => {
    if (shouldShowSealedBidTreatment({ segment, featureFlags })) {
      const currentUserNotHaveAnyOffer =
        !segment?.current_user_bidding_status ||
        [
          graph.enums.OnlineAuctionSegmentBiddingStatus.NoBid,
          graph.enums.OnlineAuctionSegmentBiddingStatus.WithdrawnBid,
        ].includes(segment?.current_user_bidding_status)

      const shouldNotShowSealedBidCTA =
        (segment?.segment_status ===
          graph.enums.OnlineAuctionSegmentStatus.Ended &&
          currentUserNotHaveAnyOffer) ||
        !segment?.__methods__?.allowToSubmitNewOffers()

      // Hide SealedTreatment CTA if the segment ended & user doesn't have any bids / offers
      if (shouldNotShowSealedBidCTA) return null

      return <SealedBidCallToAction elmId='sticky_header' />
    }

    if (isSparkOffer) {
      return <SparkOfferButton elmId='sticky_header_spark_offer_button' />
    }

    if (
      listing.listing_configuration?.asset_type ===
        graph.enums.AssetType.Foreclosure && // !bidding Status.isREO
      (listing.listing_configuration?.product_type ===
        graph.enums.ProductType.FclMarketing ||
        listing?.listing_configuration?.is_third_party_online) // bidding Status.isFCLMarketing || isThirdPartyOnline
    ) {
      return (
        // bidding Status.venueUrl
        <BidAtCountySite venueUrl={listing.venue?.venue_url}>
          <Button size='medium' role='primary' elmId='bid_at_county_button'>
            Bid at County Site
          </Button>
        </BidAtCountySite>
      )
    }

    if (segment && segment.__typename === 'OnlineAuctionSegment') {
      if (
        segment.segment_status ===
          graph.enums.OnlineAuctionSegmentStatus.Ended &&
        segment.reserve_status === graph.enums.ReserveStatus.ReserveMet
      ) {
        return segment?.subject_to_status ===
          graph.enums.SubjectToStatus.Pending &&
          listing.listing_status !== graph.enums.ListingStatus.Closed ? (
          <Text
            color='white'
            weight='heavy'
            data-elm-id='sticky_header_sale_pending'
            className={cx('after-cta')}
          >
            {SALE_PENDING}
          </Text>
        ) : (
          <Text
            color='white'
            weight='heavy'
            data-elm-id='sticky_header_sold'
            className={cx('after-cta')}
          >
            {SOLD}
          </Text>
        )
        // Check if the Auction didn't start yet OR Auction is in progress
        // And check if status is not missing (Eg. If server returns a 404), because if the status is empty by default is pending
        // Then we'll check if the user is registered or not for auction and show the corresponding CTA
      } else if (
        [
          graph.enums.OnlineAuctionSegmentStatus.Pending,
          graph.enums.OnlineAuctionSegmentStatus.Started,
          graph.enums.OnlineAuctionSegmentStatus.ReserveMet,
        ].includes(segment.segment_status) // (bidding Status.isAuctionPending || bidding Status.isAuctionInProgress)
      ) {
        if (!listing.is_current_user_registered_for_online_auction) {
          return (
            <div className={cx('register-cta')}>
              <RegistrationButton
                featureFlags={featureFlags}
                options={{
                  size: 'medium',
                  elmId: 'sticky_header_register_auction_button',
                }}
              />
            </div>
          )
        } else if (
          blueprint.listing.utils.isFclOnlineAuction(listing) &&
          segment.segment_status ===
            graph.enums.OnlineAuctionSegmentStatus.Pending
        ) {
          // bidding Status.isAuctionPending
          return (
            <div className={cx('countdown')}>
              <Text
                className='u-pt-1 u-mr-2'
                color='gray'
                data-elm-id='countdown_timer_label'
              >
                Come Back to Bid In
              </Text>
              <Text
                color='gray'
                weight='heavy'
                data-elm-id='countdown_timer_value'
              >
                <Starting
                  endTime={getStartTimeMoment(segment)}
                  className={cx('starting')}
                  currentServerTime={getServerTimeMoment(segment)}
                />
              </Text>
            </div>
          )
        }

        return (
          <Button
            role='primary'
            size='medium'
            elmId='sticky_header_place_your_bid_button'
            onClick={scrollToAnchor('bid_banner', 80)}
          >
            {PLACE_BID}
          </Button>
        )
      }
    }
    return null
  }

  return (
    <div className={cx('sticky-header')}>
      <div data-ad-space='PDP_LIGHTBOX' />
      <div className={cx('container', { hidden: !showHeader })}>
        <div className={cx('property-and-links')}>
          <div className={cx('property-info')}>
            <div className={cx('address')}>
              <AssetType listing={listing} />
              <Text
                size='large'
                data-elm-id='sticky_header_property_address_1'
                weight='heavy'
              >
                {listing.formatted_address?.[0] ?? ''}
              </Text>
              <Text
                size='large'
                data-elm-id='sticky_header_property_address_2'
                color='gray'
              >
                {listing.formatted_address?.[1] ?? ''}
              </Text>
            </div>
            <div className={cx('property-details')}>
              {fields.map(({ fieldPath, label, format, elmId }) => (
                <Detail
                  key={elmId}
                  label={label}
                  // @ts-ignore we know the summary type at this point
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                  value={property.summary ? property.summary[fieldPath] : ''}
                  elmId={elmId}
                  format={format}
                />
              ))}
            </div>
          </div>
          <div>
            {links
              .filter(({ condition }) => !condition || condition())
              .map(({ link, label, elmId }) => (
                <Button
                  role='navigation'
                  key={elmId}
                  elmId={elmId}
                  className={cx('link', { active: activeLink === link })}
                  onClick={scrollToAnchor(link)}
                >
                  {label}
                </Button>
              ))}
          </div>
        </div>
        <div className={cx('download-app', 'save-icon-button')}>
          <SavePropertyIconButton
            listing={listing}
            property={property}
            isSaved={isPropertySaved}
            actions={propertyActions}
            options={{
              size: 'medium',
              elmId: 'sticky_header_save_property_button',
              saveText: SAVE_PROPERTY_CTA_TPS,
              savedText: 'Saved',
            }}
          />
          {embeddedContext !== 'webview' && (
            <a
              href='https://auction.onelink.me/WqvL/7185fc99'
              target='_blank'
              rel='noreferrer'
            >
              <Icon name='mobile' color='info' size='big' iconStyle='regular' />
              <Text color='info'>Download App</Text>
            </a>
          )}
        </div>
        {!listing.listing_configuration?.is_direct_offer_enabled && (
          <div data-elm-id='sticky_header_cta_root' className={cx('cta')}>
            {renderLabels()}
            <div className={cx('cta-button')}>{renderCta()}</div>
          </div>
        )}
      </div>
    </div>
  )
}

const mapStateToProps = (store: any) => ({
  savedAssetsIdentifiers: store.properties.savedAssetsIdentifiers,
  user: store.user,
  featureFlags: store.featureFlags,
  similarProperties: store.propertyAnalytics.similarProperties || [],
  isPropertyReportAvailable: store.propertyAnalytics.isPropertyReportAvailable,
})

const mergeProps = (
  storeProps: any,
  actions: any,
  ownProps: { isRedesign?: boolean } = {}
) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return {
    ...storeProps,
    ...ownProps,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    actions,
  }
}

export const StickyHeader = connect(
  mapStateToProps,
  null,
  mergeProps
)(withModalHooks(StickyHeaderFunctional))
